<!-- content begin -->
<div id="content" class="no-bottom no-top">
  <div id="top"></div>

  <!-- section begin -->
  <section
    id="subheader"
    class="text-light"
    data-bgimage="url(assets/images/background/10.jpg)"
    data-stellar-background-ratio=".2"
    style="background: url(assets/images/background/16.jpg) 0% 0px / cover; "
  >
    <div class="overlay-bg t50">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1>About Us</h1>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- section close -->

  <!-- section right begin -->
  <section id="section-side" class="side-bg no-padding" data-bgcolor="#f9f9f9">
    <div
      class="image-container col-md-7 pull-left d-block d-sm-none d-md-block"
    >
      <div
        class="background-image"
        data-bgimage="url(ssets/images/background/11.jpg)"
        style="background-image: url('assets/images/background/dgt_1.jpg')"
      ></div>
    </div>

    <div class="container">
      <div class="row">
        <div class="inner-padding">
          <div class="col-md-4 offset-md-8 wow fadeIn">
            <h2 class="mb20">ABOUT DGT</h2>
            <p>
              The Directorate General of Training (DGT) in Ministry of Skill
              Development and Entrepreneurship is the apex organization for
              development and coordination at National level for the programmes
              relating to vocational training including Women's Vocational
              Training. Industrial Training Institutes are under the
              administrative and financial control of State Governments or Union
              Territory Administrations. DGT also operates Vocational Training
              Schemes in some of the specialized areas through field institutes
              under its direct control. Development of these programmes at
              national level, particularly in the area concerning common
              policies, common standards and procedures, training of instructors
              and trade testing are the responsibility of the DGT. But,
              day-to-day administration of Industrial Training Institutes rests
              with the State Governments/ Union Territories Administrations.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- section close -->

  <!-- section left begin -->
  <section id="section-side" class="side-bg no-padding" data-bgcolor="#f9f9f9">
    <div
      class="image-container col-md-7 pull-left d-block d-sm-none d-md-block"
      style="right: 0px"
    >
      <div
        class="background-image"
        data-bgimage="url(images/background/cstari.jpg)"
        style="background-image: url('assets/images/background/cstari.jpg')"
      ></div>
    </div>

    <div class="container">
      <div class="row">
        <div class="inner-padding">
          <div class="col-md-4 offset-md-12 wow fadeIn">
            <h2 class="mb20">CSTARI</h2>
            <p>
              The Central Staff Training and Research Institute (CSTARI) was
              established in the year 1968 by the Govt. of India, Ministry of
              Labour & Employment, DGE&T in collaboration with the Govt. of the
              Federal Republic of Germany. CSTARI is a premier institute with a
              sprawling campus of approximately 16 acres located in the biggest
              IT hub of eastern part of the country at Sector V, Salt Lake,
              Kolkata. From April 2015 CSTARI is under Directorate General of
              Training (DGT), Ministry of Skill Development and Entrepreneurship
              (MSDE). The various operational activities are executed by two
              different wings – namely Research and Training, and spread across
              Crafts Man training, Craft Instructor training, Modular Employable
              Skills & CoE.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- section close -->

  <!-- section right begin -->
  <section id="section-side" class="side-bg no-padding" data-bgcolor="#f9f9f9">
    <div
      class="image-container col-md-7 pull-left d-block d-sm-none d-md-block"
    >
      <div
        class="background-image"
        data-bgimage="url(images/background/niminew.jpg)"
        style="background-image: url('assets/images/background/niminew.jpg')"
      ></div>
    </div>

    <div class="container">
      <div class="row">
        <div class="inner-padding">
          <div class="col-md-4 offset-md-8 wow fadeIn">
            <h2 class="mb20">NIMI</h2>
            <p>
              National Instructional Media Institute (NIMI) was set up in the
              name of Central Instructional Media Institute (CIMI) in Chennai in
              December 1986 by the Government of India as a Subordinate Office
              under Directorate General of Employment and Training (DGE&T) with
              the assistance from Government of Germany through GTZ (German
              Agency for Technical Co-operation) as the executing agency.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- section close -->

  <!-- section begin -->
  <section id="section-services">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-12">
          <div class="row sequence">
            <!-- feature box begin -->
            <div class="col-md-4 mb40 sq-item wow sq-item wow">
              <div class="feature-box style-2">
                <i class="fa fa-eye"></i>
                <div class="text">
                  <h3>Our Vision</h3>
                  Nimi envisages to scale global benchmarks in vocational education as a Nodal organization for curricula, instructional media packages and Test Item development for vocational courses in the country.
                </div>
              </div>
            </div>
            <!-- feature box close -->

            <!-- feature box begin -->
            <div class="col-md-4 feature-box mb40 sq-item wow">
              <div class="feature-box style-2">
                <i class="fa fa-bullseye"></i>
                <div class="text">
                  <h3>Our Mission</h3>
                  Nimi proposes to accelerate vocational training in the country through systemic curriculum development, production, dissemination of instructional media packages and training on instructional media by closely interacting with the State / UT Govts., Industries, ITIs and organizations involved in Vocational Training.

                </div>
              </div>
            </div>
            <!-- feature box close -->

             <!-- feature box begin -->
             <div class="col-md-4 feature-box mb40 sq-item wow">
              <div class="feature-box style-2">
                <i class="fa fa-object-group"></i>
                <div class="text">
                  <h3>Objective</h3>
                  NIMI has been functioning as a Nodal Agency to develop Instructional Materials, e-content, Question Banks, Train media developers and trainers, enable translation of books into Hindi and other regional languages, network with other vocational stakeholders, create resource centers for vocational courses, promote research in the field of development of instructional materials and offer consultancy services.

                </div>
              </div>
            </div>
            <!-- feature box close -->

          </div>
        </div>

        <!-- <div class="col-md-4">
          <figure class="picframe invert transparent hover-shadow">
            <span class="overlay-v">
              <span class="v-center">
                <span>
                  <a
                    id="play-video"
                    class="video-play-button popup-youtube"
                    href="https://www.youtube.com/watch?v=CmCIZ_aUAeQ"
                  >
                    <span></span>
                  </a>
                </span>
              </span>
            </span>
            <img src="images/misc/3.jpg" class="img-fullwidth" alt="" />
          </figure>
        </div> -->
      </div>
    </div>
  </section>
  <!-- section close -->

  <!-- section begin -->
  <section class="bg-color text-light pt40 pb40">
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <h2 class="no-bottom">NIMI Activities</h2>
        </div>
      </div>
    </div>
  </section>
  <!-- section close -->



  <!-- section begin -->
  <section id="section-services">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-12">
          <div class="row sequence">
            <!-- feature box begin -->
            <div class="col-md-12 ">
              <div class="style-2">
                <!-- <i class="icon-pencil"></i> -->
                <div class="text list_text">
                  <!-- <h3>Our Vision</h3> -->
                  <!-- <p>
                    Nimi envisages to scale global benchmarks in vocational education as a Nodal organization for curricula, instructional media packages and Test Item development for vocational courses in the country.
                  </p> -->

                  <p><i class="fa fa-check " aria-hidden="true"></i>Development of Instructional Material</p>

                  <p><i class="fa fa-check " aria-hidden="true"></i>Development of Question Bank</p>

                  <p><i class="fa fa-check " aria-hidden="true"></i>Translation of IMPs in Hindi and other Regional Languages</p>

                  <p><i class="fa fa-check " aria-hidden="true"></i>Awareness Training for Instructors</p>

                  <p><i class="fa fa-check " aria-hidden="true"></i>Online Learning - Digitization of IMP and preparation of eLearning module for IMP</p>

                  <p><i class="fa fa-check " aria-hidden="true"></i>Development of Video Instructional Program</p>

                  <p><i class="fa fa-check " aria-hidden="true"></i>Development of Terminal Competency</p>

                  <p><i class="fa fa-check " aria-hidden="true"></i>Media Development Training</p>

                  <p><i class="fa fa-check " aria-hidden="true"></i>Printing, publishing and Marketing of the Products</p>



                </div>
              </div>
            </div>
            <!-- feature box close -->



          </div>
        </div>

        <!-- <div class="col-md-4">
          <figure class="picframe invert transparent hover-shadow">
            <span class="overlay-v">
              <span class="v-center">
                <span>
                  <a
                    id="play-video"
                    class="video-play-button popup-youtube"
                    href="https://www.youtube.com/watch?v=CmCIZ_aUAeQ"
                  >
                    <span></span>
                  </a>
                </span>
              </span>
            </span>
            <img src="images/misc/3.jpg" class="img-fullwidth" alt="" />
          </figure>
        </div> -->
      </div>
    </div>
  </section>
  <!-- section close -->

  <!-- section begin -->
  <!-- <section id="section-team" class="no-padding">
    <div class="container-fluid">
      <div class="row no-gutters">
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="profile_pic text-center">
            <figure class="picframe sc-icon mb20">
              <div class="icons">
                <a href="#"><i class="fa fa-facebook fa-lg"></i></a>
                <a href="#"><i class="fa fa-twitter fa-lg"></i></a>
                <a href="#"><i class="fa fa-linkedin fa-lg"></i></a>
                <a href="#"><i class="fa fa-google-plus fa-lg"></i></a>
              </div>
              <img src="images/team/1.jpg" class="img-fluid" alt="" />
            </figure>

            <h3>Oscar Helman</h3>
            <span class="subtitle">Founder & CEO</span>
          </div>
        </div>

        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="profile_pic text-center">
            <figure class="picframe sc-icon mb20">
              <div class="icons">
                <a href="#"><i class="fa fa-facebook fa-lg"></i></a>
                <a href="#"><i class="fa fa-twitter fa-lg"></i></a>
                <a href="#"><i class="fa fa-linkedin fa-lg"></i></a>
                <a href="#"><i class="fa fa-google-plus fa-lg"></i></a>
              </div>
              <img src="images/team/2.jpg" class="img-fluid" alt="" />
            </figure>

            <h3>Isaac Nicholas</h3>
            <span class="subtitle">Founder & CEO</span>
          </div>
        </div>

        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="profile_pic text-center">
            <figure class="picframe sc-icon mb20">
              <div class="icons">
                <a href="#"><i class="fa fa-facebook fa-lg"></i></a>
                <a href="#"><i class="fa fa-twitter fa-lg"></i></a>
                <a href="#"><i class="fa fa-linkedin fa-lg"></i></a>
                <a href="#"><i class="fa fa-google-plus fa-lg"></i></a>
              </div>
              <img src="images/team/3.jpg" class="img-fluid" alt="" />
            </figure>

            <h3>Rose Shipp</h3>
            <span class="subtitle">Founder & CEO</span>
          </div>
        </div>

        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="profile_pic text-center">
            <figure class="picframe sc-icon mb20">
              <div class="icons">
                <a href="#"><i class="fa fa-facebook fa-lg"></i></a>
                <a href="#"><i class="fa fa-twitter fa-lg"></i></a>
                <a href="#"><i class="fa fa-linkedin fa-lg"></i></a>
                <a href="#"><i class="fa fa-google-plus fa-lg"></i></a>
              </div>
              <img src="images/team/4.jpg" class="img-fluid" alt="" />
            </figure>

            <h3>John Arnold</h3>
            <span class="subtitle">Founder & CEO</span>
          </div>
        </div>
      </div>
    </div>
  </section> -->
  <!-- section close -->
</div>
<!-- content close -->

<!-- <div class="container">
  <h3>Upload File</h3>


  <form [formGroup]="fileUploadForm" (ngSubmit)="onFormSubmit()">
    <div class="row">
      <div class="col-sm-12">
        <div>
          <h6 class="head-title margin-top-8"><span>Select Image File</span></h6>
        </div>
      </div>
      <div class="col-sm-6">

        <div class="custom-file">

          <input type="text" formControlName="uploadedText" >
          <input type="text" formControlName="uploadedText1" >

          <input type="file" id="customFile" name="uploadedImage"
            (change)="onFileSelect($event)" accept="image/x-png,image/jpeg" data-max-size="111" #UploadFileInput>

            <input type="file" id="customFile" name="uploadedPdf"
            (change)="onFileSelectRes($event)" accept="application/pdf" #uploadFileResInput>

          <label for="customFile">{{fileInputLabel || 'Choose File'}}</label>

        </div>

      </div>

      <div class="col-sm-6"> <button class="btn btn-primary" type="submit">Upload</button> </div>

    </div>
  </form>

<h2>Our Details</h2>

<div>
  <ul>
    <li>REF No: {{this.rollno}}</li>
    <li>Text1: {{this.text1}}</li>
    <li>Text2: {{this.text2}}</li>
    <li>Image: <img src="http://localhost:5001/{{this.uplImg}}"> </li>

  </ul>
</div>
</div> -->




<style>
  .list_text i{
    color: #F56B55;
    font-size: 17px;
    padding-right: 5px;
  }
</style>
